module.exports = __webpack_public_path__ + "img/Russian-Church-Sofia.a9bf1f5b.jpg";